import React from 'react';
import { Control, useWatch } from 'react-hook-form';
import { Typography } from '@mui/material';
import { formatCurrency } from 'utils';
import { DealBuilderFormValues } from '../../../types';
import { calculateNetTrade } from '../../../lib';

interface Props {
  control: Control<DealBuilderFormValues>;
  rowIndex: number;
}

export const NetTradeCell = ({ control, rowIndex }: Props) => {
  const [tradeInValue, amountOwed, otherCharges] = useWatch({
    control,
    name: [
      `pricing.tradeIn.${rowIndex}.tradeInValue`,
      `pricing.tradeIn.${rowIndex}.amountOwed`,
      `pricing.tradeIn.${rowIndex}.otherCharges`,
    ],
  });
  const netTrade = calculateNetTrade({ tradeInValue, amountOwed, otherCharges });

  return (
    <Typography variant="body2" fontWeight={600}>
      {formatCurrency(netTrade, true)}
    </Typography>
  );
};
